<app-header [class]="brand"></app-header>
<main [class]="brand">
  <router-outlet></router-outlet>
</main>
